export default "__VITE_ASSET__41113af5__"